import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {PdfViewerComponent} from 'ng2-pdf-viewer';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import Viewer from 'viewerjs';

@Component({
  selector: 'app-attachment-viewer',
  templateUrl: './attachment-viewer.component.html',
  styles: []
})
export class AttachmentViewerComponent extends ExcTranslation implements AfterViewInit {

  @ViewChild('imgHost') imgHost: ElementRef<HTMLImageElement>;
  @ViewChild('vidHost') vidHost: ElementRef<HTMLVideoElement>;
  @ViewChild(PdfViewerComponent) pdfViewerComponent: PdfViewerComponent;

  @Input() AuditID: number;
  @Input() InventoryID: number;
  @Input() Url: string;
  _item: {AttachmentID: number, AttachmentData: string, AttachmentMIME: string, AttachmentName: string};
  get item(): any {
    return this._item;
  }

  @Input('item')
  set item(value: any) {
    this._item = value;
    this.loadItem();
  }

  private viewer: Viewer;
  private excRestService: any = ExcCoreModule.Services().ExcRest;
  isLoading = false;
  private supportedMIMEs: string[] = [
    'image/.*',
    'video/.*',
    'application/pdf'
  ];
  notSupportedMIME = false;
  private throttleId: any;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit() {
    if (this._item === undefined || this._item === null) {
      return;
    }
    this.changeDetectorRef.detectChanges();
  }
private handleResize(e) {
    this.initImageViewer();
}
  private initImageViewer() {
    this.destroyImageViewer();
    const _self = this;
    setTimeout(() => {
      _self.viewer = new Viewer(_self.imgHost.nativeElement, {
        inline: true,
        title: false,
        navbar: false,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          prev: false,
          play: false,
          next: false,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        },
        button: false,
        fullscreen: true,
        transition: false
      });
    }, 100);
  }
  private destroyImageViewer() {
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
  }
  private loadItem() {
    this.notSupportedMIME = false;

    if (this.throttleId) {
      clearTimeout(this.throttleId);
    }
    setTimeout(async () => {
      this.startLoadingAnimation();

      if (!this.isMIMESupported()) {
        this.notSupportedMIME = true;
        this.stopLoadingAnimation();
      } else {
        this.notSupportedMIME = false;
      }

      if (this._item.AttachmentData === undefined || this._item.AttachmentData === null) {
        this._item.AttachmentData = await this.getCurrentResourceBinary();
      }

      if (this.isCurrentItemImage()) {
        this.initImageViewer();
      } else {
        this.destroyImageViewer();
      }

      if (this.isCurrentItemVideo()) {
        this.vidHost.nativeElement.load();
      }

      this.stopLoadingAnimation();
    }, 80);
  }

  private async getCurrentResourceBinary() {

    const queryParams = {
      AuditID: this.AuditID,
      InventoryID: this.InventoryID,
      AttachmentID: this._item.AttachmentID,
      format: 'image'
    };

    // for video and pdf stream url request
    if (this.isCurrentItemVideo() || this.isCurrentItemPDF()) {
      queryParams['format'] = 'video';
      return this.excRestService.computeUrl(this.Url, queryParams);
    }

    const url = this.excRestService.computeUrl(this.Url, queryParams);
    const response = await this.excRestService.sget(url, null, {cid: ExcCoreModule.Guid}).toPromise();

    // for image request
    if (response !== undefined) {
      if (this.isCurrentItemImage()) {
        return 'data:' + this._item.AttachmentMIME + ';base64,' + response.response.data[0].AttachmentData;
      }
    }
  }
  isMIMESupported() {
    return this.supportedMIMEs.some(mime => new RegExp(mime).test(this._item.AttachmentMIME));
  }
  isCurrentItemVideo() {
    return this._item.AttachmentMIME.indexOf('video/') > -1;
  }
  isCurrentItemImage() {
    return this._item.AttachmentMIME.indexOf('image/') > -1;
  }
  isCurrentItemPDF() {
    return this._item.AttachmentMIME.indexOf('application/pdf') > -1;
  }
  private startLoadingAnimation() {
    this.isLoading = true;
  }
  private stopLoadingAnimation() {
    this.isLoading = false;
  }
}
